"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetDeleteBlogStage = exports.changeDeleteProperty = exports.changeDeleteLists = exports.changeDeleteForm = exports.changeDeleteEmails = exports.changeDeleteEmailType = exports.changeDeleteCommentsForm = exports.changeBlogNameConfirmation = void 0;

var _DeleteBlog = _interopRequireWildcard(require("../../stagedObjects/DeleteBlog"));

var changeBlogNameConfirmation = _DeleteBlog.default.changeProperty(_DeleteBlog.BLOG_NAME_CONFIRMATION);

exports.changeBlogNameConfirmation = changeBlogNameConfirmation;

var changeDeleteCommentsForm = _DeleteBlog.default.changeProperty(_DeleteBlog.DELETE_COMMENTS_FORM);

exports.changeDeleteCommentsForm = changeDeleteCommentsForm;

var changeDeleteEmailType = _DeleteBlog.default.changeProperty(_DeleteBlog.DELETE_EMAIL_TYPE);

exports.changeDeleteEmailType = changeDeleteEmailType;

var changeDeleteEmails = _DeleteBlog.default.changeProperty(_DeleteBlog.DELETE_EMAILS);

exports.changeDeleteEmails = changeDeleteEmails;

var changeDeleteForm = _DeleteBlog.default.changeProperty(_DeleteBlog.DELETE_FORM);

exports.changeDeleteForm = changeDeleteForm;

var changeDeleteLists = _DeleteBlog.default.changeProperty(_DeleteBlog.DELETE_LISTS);

exports.changeDeleteLists = changeDeleteLists;

var changeDeleteProperty = _DeleteBlog.default.changeProperty(_DeleteBlog.DELETE_PROPERTY);

exports.changeDeleteProperty = changeDeleteProperty;
var resetDeleteBlogStage = _DeleteBlog.default.resetChangesToStagedObject;
exports.resetDeleteBlogStage = resetDeleteBlogStage;